import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { Table } from 'design-react-kit';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { TableLP } from '@redturtle/iosanita-alp';

const messages = defineMessages({
  nome: {
    id: 'alp_table_nome',
    defaultMessage: 'Nome e Cognome',
  },
  reparto: {
    id: 'alp_reparto',
    defaultMessage: 'Reparto',
  },
  prestazioni: {
    id: 'alp_prestazioni',
    defaultMessage: 'Prestazioni',
  },

  noResult: {
    id: 'noResult',
    defaultMessage: 'Nessun risultato trovato',
  },
});

const Results = ({ items, isEditMode, resRef }) => {
  const intl = useIntl();

  return (
    <>
      {items?.length > 0 ? (
        <div id="alp-results" className="shadow" role="region" aria-live="polite" ref={resRef}>
          <Table>
            <thead>
              <tr className="d-none d-lg-table-row">
                <th>{intl.formatMessage(messages.nome)}</th>
                <th>{intl.formatMessage(messages.reparto)}</th>
                <th>{intl.formatMessage(messages.prestazioni)}</th>
              </tr>
            </thead>
            {items.map((item, i) => (
              <tbody>
                <tr key={i}>
                  <td className="nome">
                    <UniversalLink item={item}>{item.title}</UniversalLink>
                  </td>
                  <td className="reparto">
                    {/* uo riferimento */}

                    {/* {item.uo_riferimento[0]?.city || item.uo_riferimento[0]?.zip_code || item.uo_riferimento[0]?.street ? (
                      <div>
                        {item.uo_riferimento[0]["@id"] && (
                          <UniversalLink item={!isEditMode ? item.uo_riferimento[0] : null} href={isEditMode ? "#" : null}>
                            {item.uo_riferimento[0].title}
                          </UniversalLink>
                        )}

                        {item.uo_riferimento[0].street && <p>{item.uo_riferimento[0].street}</p>}
                        {(item.uo_riferimento[0].city || item.uo_riferimento[0].zip_code) && (
                          <p>
                            {item.uo_riferimento[0].zip_code} {item.uo_riferimento[0].city}
                          </p>
                        )}
                      </div>
                    ) : item.uo_riferimento[0]?.title ? (
                      <div>{item.uo_riferimento[0].title}</div>
                    ) : (
                      <div>-</div>
                    )} */}
                    {item.uo_riferimento[0]?.title ? <div>{item.uo_riferimento[0].title}</div> : <div>-</div>}
                  </td>
                  <td className="prestazioni">
                    <TableLP content={item} />
                  </td>
                </tr>
              </tbody>
            ))}
          </Table>
        </div>
      ) : (
        <div className="message px-4">{intl.formatMessage(messages.noResult)}</div>
      )}
    </>
  );
};

export default Results;
